<div [hidden]="loading">
  <div style="padding:12px; display: flex; justify-content: center">
    <h1>eDiscovery Platform Agreement</h1>
  </div>
  <mat-dialog-content>
    <!-- TODO: Printable version -->
    <div [innerHtml]="eulaContent$ | async"></div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <mat-checkbox [(ngModel)]="agreeChecked">I have read and accept the eDiscoveryPlatform Services Agreement</mat-checkbox>
    <button mat-raised-button color="primary" (click)="ok()" [disabled]="!agreeChecked">Continue</button>
  </mat-dialog-actions>
</div>
